import React from 'react';
import { Button } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
var BUTTON_TYPES = {
  transparent: 'transparent',
  'secondary-white': 'secondary',
  'secondary-dark': 'secondaryBlue',
  dark: 'dark',
  white: 'white',
  'transparent-white': 'transparentWhite',
  blue: 'primary'
};

var ButtonAdapter = function ButtonAdapter(_ref) {
  var _ref$class = _ref["class"],
      className = _ref$class === void 0 ? '' : _ref$class,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? '#' : _ref$href,
      text = _ref.text,
      _ref$arrow = _ref.arrow,
      arrow = _ref$arrow === void 0 ? true : _ref$arrow,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'blue' : _ref$type,
      _ref$$styles = _ref.$styles,
      $styles = _ref$$styles === void 0 ? {} : _ref$$styles,
      template_id = _ref.template_id;
  return /*#__PURE__*/_jsx(Button, {
    $styles: $styles,
    className: className,
    $withArrow: arrow,
    $buttonType: BUTTON_TYPES[type],
    $size: "medium",
    href: href,
    templateId: template_id,
    children: text
  });
};

export default ButtonAdapter;